export class WidaPredictionDetails {
    StartingPredictedScore: number
    CurrentPredictedScore: number
    FinalPredictedScoreNoUsage: number
    FinalPredictedScoreLowUsage: number
    FinalPredictedScoreMediumUsage: number
    FinalPredictedScoreHighUsage: number
    ConvertedTo: string // WIDA, ELPAC, TELPAS
    ErrorCodesJson: string[]

    static notEnoughData(widaPredictionDetails: WidaPredictionDetails) {
        return (
            widaPredictionDetails.ErrorCodesJson &&
            widaPredictionDetails.ErrorCodesJson.length > 0 &&
            widaPredictionDetails.ErrorCodesJson.includes(WidaPredictionErrorCodes.NotEnoughData)
        );
    }

    static gradeLevelNotFound(widaPredictionDetails: WidaPredictionDetails) {
        return (
            widaPredictionDetails.ErrorCodesJson &&
            widaPredictionDetails.ErrorCodesJson.length > 0 &&
            widaPredictionDetails.ErrorCodesJson.includes(WidaPredictionErrorCodes.GradeLevelNotFound)
        );
    }
}

export enum WidaPredictionErrorCodes {
    NotEnoughData = 'NotEnoughData',
    GradeLevelNotFound = 'GradeLevelNotFound'
}

export enum WidaUsageLevels {
    NoUsage,
    LowUsage,
    MedUsage,
    HighUsage
}